import { beaconAssert, beaconFail } from "./assertions.js";
import { DomUtils } from "./dom-utils.js";
function removeAllCurrencySymbols(text) {
    return text.replace(/\p{Sc}/gu, "");
}
function removeAnythingWithinParenthesis(text) {
    return text.replace(/\(.*?\)/g, "");
}
function extractAllNumbers(text) {
    const raw = text.match(/\d+[.,]?\d*/g) ?? [];
    const numbers = [];
    for (const value of raw) {
        const number = parseFloat(value.replace(",", "."));
        beaconAssert(!isNaN(number), `Failed to parse number from '${value}'`);
        numbers.push(number);
    }
    return numbers;
}
export const PriceUtils = {
    extractPriceFromElement(element) {
        let text = DomUtils.extractNonStrikeOutText(element);
        text = removeAllCurrencySymbols(text);
        text = removeAnythingWithinParenthesis(text);
        const numbers = extractAllNumbers(text);
        if (numbers.length === 1) {
            return numbers[0];
        }
        else if (numbers.length === 2) {
            // We assume two numbers is a price range and we compute the median
            return (numbers[0] + numbers[1]) / 2;
        }
        else {
            beaconFail(`Price '${text}' does not match any of the expected price formats`);
        }
    },
};
//# sourceMappingURL=price-utils.js.map